import { render, staticRenderFns } from "./Sends.vue?vue&type=template&id=7c0d19e0&"
import script from "./Sends.vue?vue&type=script&lang=js&"
export * from "./Sends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports